// Bootstrap del Dashboard JMA AFAC.
//
// El componente App maneja internamente el ciclo de vida de MSAL.js a
// través de initAuth() (auth/auth-provider.js). Aquí sólo montamos la
// aplicación; el splash de carga vive en LoadingScreen y se muestra
// mientras MSAL termina handleRedirectPromise.

import { render } from 'preact'
import { html } from 'htm/preact'
import { App } from './app.js'

const mount = document.getElementById('app')
if (!mount) {
  // eslint-disable-next-line no-console
  console.error('[JMA AFAC] No se encontró el contenedor #app en index.html.')
} else {
  render(html`<${App} />`, mount)
}
